import React from 'react';

import { useQuery } from '@apollo/client';
import { faFile } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Avatar, Grid, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import dayjs from 'dayjs';

import signatureGQLSchemas from '../../../../../services/signatures/gqlSchema';

const AlreadySigned = ({ signUuid, contactInfoId, contact }) => {
  const { data } = useQuery(signatureGQLSchemas.Query.recoveryCandidateDocument, {
    variables: {
      signUuid: signUuid,
      contactInfoId: contactInfoId,
      category: 'SEPA_CANDIDATE',
    },
  });

  return (
    <Grid item xs={12}>
      <Alert severity='success'>Informations signées</Alert>
      {data?.recoveryCandidateDocument.map(doc => {
        return (
          <Grid item xs={12}>
            <List key={doc.id}>
              <ListItemButton key={doc.id} href={doc.public_url}>
                <ListItem sx={{ alignItems: 'flex-start' }}>
                  <ListItemAvatar>
                    <Avatar>
                      <FontAwesomeIcon icon={faFile} />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={doc.filename}
                    secondary={<>Publié le {dayjs(doc.createdAt).format('DD/MM/YYYY à HH:mm:ss')}</>}
                  />
                </ListItem>
              </ListItemButton>
            </List>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default React.memo(AlreadySigned);
